import { styled } from '@linaria/react';
import { fonts, layout, semantic, size, space } from '../../theme/tokens';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${semantic.bg.overlayModal};
  z-index: 100;
  opacity: 0;
  pointer-events: none;
  transition: opacity 300ms ease;

  &[data-open='true'] {
    opacity: 1;
    pointer-events: auto;
  }

  &[data-blur='true'] {
    backdrop-filter: blur(${size.blur['blur-lg']});
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    &[data-placement='left'] {
      left: var(--drawer-desktop-offset, ${layout.sideNavWidth});
    }
  }
`;

export const Panel = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--shell-mobile-nav-height, 0px);
  top: var(--drawer-mobile-top, auto);
  height: auto;
  max-height: 100vh;
  background: ${semantic.bg.canvas};
  z-index: 101;
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  transition: transform 300ms cubic-bezier(0.65, 0, 0.35, 1);
  border-radius: ${size.radius['radius-xl']} ${size.radius['radius-xl']} 0 0;

  &[data-open='true'] {
    transform: translateY(0);
  }

  &[data-placement='left'] {
    top: var(--announcement-banner-height, 0px);
    bottom: var(--shell-mobile-nav-height, 0px);
    height: auto;
    max-height: calc(
      100vh - var(--shell-mobile-nav-height, 0px) - var(--announcement-banner-height, 0px)
    );
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    top: var(--announcement-banner-height, 0px);
    left: auto;
    right: 0;
    bottom: 0;
    width: var(--drawer-width, 520px);
    height: auto;
    max-height: calc(100vh - var(--announcement-banner-height, 0px));
    max-width: 100vw;
    border-radius: 0;
    transform: translateX(100%);

    &[data-open='true'] {
      transform: translateX(0);
    }

    &[data-placement='left'] {
      top: var(--announcement-banner-height, 0px);
      bottom: 0;
      height: auto;
      max-height: calc(100vh - var(--announcement-banner-height, 0px));
      left: var(--drawer-desktop-offset, ${layout.sideNavWidth});
      right: auto;
      transform: translateX(calc(-100% - var(--drawer-desktop-offset, ${layout.sideNavWidth})));
    }

    &[data-placement='left'][data-open='true'] {
      transform: translateX(0);
    }
  }
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const Footer = styled.div`
  flex-shrink: 0;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${space['space-400']};
  right: ${space['space-400']};
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space['space-100']};
  color: ${semantic.text.primary};
  font-size: ${fonts.size.lg};
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
